export default "__VITE_ASSET__587ee865__"